import { alpha, Box, Typography } from "@mui/material";
import { ROLL_COLORS } from "./RollColors";

export const RollBox = ({
	rollName,
	position,
	rollRef,
	color,
}: {
	rollName: string | null;
	position: "TR" | "BR";
	rollRef?: React.RefObject<HTMLDivElement | null>;
	color?: (typeof ROLL_COLORS)[0];
}) => {
	const positionLabel = position === "TR" ? "TOP" : "BOTTOM";

	return (
		<Box
			ref={rollRef}
			sx={{
				backgroundColor: color?.bg || "background.paper",
				borderRadius: 1.5,
				p: 1,
				border: "2px solid",
				borderColor: color?.border || "divider",
				minWidth: 80,
				transition: "all 0.2s ease",
				"&:hover": {
					transform: "scale(1.02)",
					boxShadow: `0 2px 8px ${alpha(color?.border || "#000", 0.25)}`,
				},
			}}
		>
			<Typography
				variant="caption"
				sx={{
					fontSize: "0.6rem",
					color: "text.secondary",
					display: "block",
					fontWeight: 600,
					textTransform: "uppercase",
					letterSpacing: "0.03em",
				}}
			>
				{positionLabel}
			</Typography>
			<Typography
				variant="body2"
				fontWeight={700}
				sx={{
					fontSize: "0.8rem",
					color: color?.text || "text.primary",
					fontFamily: "monospace",
				}}
			>
				{rollName || "—"}
			</Typography>
		</Box>
	);
};
